<template>
  <transition
    mode="out-in"
    :enter-active-class="`transition ease-in-out ${props.duration}`"
    :enter-from-class="`transform opacity-0 ${props.translateY || ''}`"
    enter-to-class="transform opacity-100"
    :leave-active-class="`transition ease-in-out ${props.duration}`"
    leave-from-class="transform opacity-100"
    :leave-to-class="`transform opacity-0 ${props.translateY || ''}`"
  >
    <slot />
  </transition>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    duration?: string
    translateY?: string
  }>(),
  {
    duration: 'duration-100',
  },
)
</script>
